/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-05-26 17:42:48
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-05-27 11:54:56
 * @FilePath: /dsicm-admin-web/src/views/StandardDatabase/common/foodTab.config.js
 */
export default{
    data(){
        return{
            foodTable:[
                    // showOverflowTooltip: true
                {
                    label: '名称',
                    align: 'center',
                    prop: 'name',
                },
                {
                    label: '简称',
                    align: 'center',
                    prop: 'abbreviation',
                },
                {
                    label: '状态',
                    align: 'center',
                    render: (h, scope) => {
                        return <span slot="reference">{scope.row.status ? '停用' : '启用'}</span>
                    },
                },
                {
                    label: '操作',
                    align: 'center',
                    // render: (h, scope) => {
                    //     return <div slot="reference">
                    //          <el-button type="primary">编辑</el-button>
                    //          <el-button type="primary">主要按钮</el-button>
                    //          <el-button type="primary">主要按钮</el-button>
                    //     </div>
                    // },
                    render: (h, scope) => {
                        return h('div', [
                            h(
                                'el-button',
                                {
                                    props: { type: 'text', size: 'mini' },
                                    on: {
                                        click: () => {
                                            this.editTableItemHandel(scope)
                                        },
                                    },
                                }, '编辑'
                            ),
                            h(
                                'el-button',
                                {
                                    props: { type: 'text', size: 'mini' },
                                    attrs: {
                                        disabled: scope.row.disabled ? true : false,
                                    },
                                    on: {
                                        click: () => {
                                            this.removeHandel(scope)
                                        },
                                    },
                                }, '删除'
                            ),
                            h(
                                'el-button',
                                {
                                    props: { type: 'text', size: 'mini' },
                                    attrs: {
                                        disabled: scope.row.disabled ? true : false,
                                    },
                                    on: {
                                        click: () => {
                                            this.updateStatusFood(scope)
                                        },
                                    },
                                }, scope.row.status ? '启用':'停用'
                            ),
                        ])
                    },
                },
            ]
        }
    }
}